<script lang="ts">
  import 'nouislider/dist/nouislider.css';
  import noUiSlider from 'nouislider';
  import InputLabel from './InputLabel.svelte';

  type Props = {
    label: string;
    min: Date;
    max: Date;
    value?: [Date, Date];
    onchange: (value: [Date, Date]) => void;
  };

  const { label, min, max, value, onchange }: Props = $props();

  let ref: HTMLElement;
  const minNum = min.getTime();
  const maxNum = max.getTime();
  const valueDays = $derived(
    value
    ? [value[0], value[1]]
    : [min, max]
  );
  const valueNums = [valueDays[0].getTime(), valueDays[1].getTime()];

  const handleChange = (values: number[]) => {
    onchange([new Date(values[0]), new Date(values[1])]);
  };

  $effect(() => {
    if (!ref) return;

    const slider = noUiSlider.create(ref, {
      start: valueNums,
      step: 10 * 60 * 1000,
      range: {
        min: minNum,
        max: maxNum
      },
    });

    slider.on('update', (values) => {
      const from = Number(values[0]);
      const to = Number(values[1]);

      handleChange([from, to]);
    });

    return () => {
      slider.destroy();
    };
  });
</script>

<div class="time-range-input">
  <InputLabel>{label}</InputLabel>
  <div class="wrapper">
    <div class="px-2 mt-3 mb-3">
      <div bind:this={ref} class="range-slider"></div>
    </div>
    <div class="labels flex justify-between text-[.8rem] text-white">
      <span>{valueDays[0].toLocaleTimeString('en-UK', { hour: 'numeric', minute: 'numeric' })}</span>
      <span>{valueDays[1].toLocaleTimeString('en-UK', { hour: 'numeric', minute: 'numeric' })}</span>
    </div>
  </div>
</div>

<style>
  .time-range-input :global(.noUi-handle) {
    background: theme('colors.pink');
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 99999px;
    box-shadow: none;
    right: -12px;
    top: -12px;
  }

  .time-range-input :global(.noUi-horizontal) {
    height: 2px;
  }

  .time-range-input :global(.noUi-handle:before),
  .time-range-input :global(.noUi-handle:after) {
    display: none;
  }

</style>